import React, { PureComponent } from 'react'
import { Button, ButtonToolbar } from 'reactstrap'
import { reduxForm } from 'redux-form'
import uuid from 'uuid'
import { Question } from './Question'

class WizardFormOne extends PureComponent {
  render () {
    const { handleSubmit, previousPage } = this.props

    return (

      <form className='form wizard__form' onSubmit={handleSubmit}>
        <div className='form__form-group'>
          {
            this.props.data.map(data => {
              return <Question
                helpText={data.helpText}
                option={data.answers}
                question={data.question}
                answers={data.answers}
                questionType={data.questionType}
                key={uuid()} />
            })
          }
        </div>
        <ButtonToolbar className='form__button-toolbar wizard__toolbar'>
          <Button color='primary' type='button' className='previous' onClick={previousPage}>Back</Button>
          <Button color='primary' type='submit' className='next'>Next</Button>
        </ButtonToolbar>
      </form>
    )
  }
}

export default reduxForm({
  form: 'wizard', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
})(WizardFormOne)



// WEBPACK FOOTER //
// ./src/components/assessment/components/WizardFormTwo.js